


























































































































































import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import { QueryBuilder } from '@/classes/QueryBuilder';
import moment from 'moment';
import DepartmentLazydropdown from '@/components/lazyDropdown/DepartmentLazydropdown.vue';
import DateRangeForReport from '@/components/DateRangeForReports.vue';
import { Permission as PermissionEnum } from '@/enums/Permission';
import { Tag } from 'element-ui';
import TerritoryTypeAutocomplete from '@/components/resources-autocomplete/TerritoryTypeAutocomplete.vue';
import UserLazydropdown from '@/components/lazyDropdown/UserLazydropdown.vue';
import swal from 'sweetalert2';
import TerritoryCascaderDropdown from '@/components/resources-autocomplete/TerritoryCascaderDropdown.vue';
import PaginationComponentMixin from '@/mixins/PaginationComponent';
import ChannelLazydropdown from '@/components/lazyDropdown/ChannelLazydropdown.vue';
import DepartmentCategoryLazyDropdown from '@/components/lazyDropdown/DepartmentCategoryLazyDropdown.vue';
import DepartmentLocationTypeLazyDropdown from '@/components/lazyDropdown/DepartmentLocationTypeLazyDropdown.vue';
import BadgeLazydropdown from '@/components/lazyDropdown/BadgeLazydropdown.vue';
import DateRangeForReports from '@/components/DateRangeForReports.vue';

const flatPicker = require('vue-flatpickr-component');
@Component({
	components: {
		DateRangeForReports,
		BadgeLazydropdown,
		DepartmentLocationTypeLazyDropdown,
		DepartmentCategoryLazyDropdown,
		ChannelLazydropdown,
		TerritoryCascaderDropdown,
		UserLazydropdown,
		TerritoryTypeAutocomplete,
		DepartmentLazydropdown,
		flatPicker,
		DateRangeForReport,
		[Tag.name]: Tag,
	},
})
export default class SurveyReport extends Mixins(PaginationComponentMixin) {
	public downloading: boolean = false;
	public surveyReports = [];
	public queryBuilder: QueryBuilder = new QueryBuilder();
	private surveyTypes = ['consumer', 'outlet'];
	public formData: any = {
		territory_ids: '',
		department_type_ids: '',
		department_category_ids: '',
		location_type_ids: '',
		badge_ids: '',
		for: '',
		user_ids: '',
		range: '',
		participant_code: '',
	};

	public firstDate = '';
	public lastDate = '';
	public loading: boolean = false;
	public filterData = null;
	public query: any = '';

	public onClickGenerate() {
		this.pagination.currentPage = 1;
		this.fetchReport();
	}

	public notification(message: string) {
		this.$notify({
			type: 'warning',
			message: message,
			title: 'Validation Error!',
		});
	}

	@Watch('pagination.currentPage', { deep: true })
	async fetchReport() {
		if (!this.formData.for || this.formData.for.length === 0) {
			this.notification('The Survey For field is required.');
		} else if (!this.formData.range) {
			this.notification('The Date Range field is required.');
		} else {
			this.loading = true;
			this.$http
				.get(this.$api3(`/survey-report${this.$toQueryString(this.formData)}&page=${this.pagination.currentPage}`))
				.then((response) => {
					this.surveyReports = response.data.surveyReports.data;
					this.setPagination(response.data.surveyReports);
					if (this.surveyReports.length == 0) {
						this.$notify({
							type: 'warning',
							message: 'There is no reports set in selected filters',
							title: 'No data found!',
						});
					}
				})
				.catch((error) => {
					(
						this.$refs.formValidator as Vue & {
							setErrors: (errors: []) => any;
						}
					).setErrors(error.response.data.errors);
				})
				.finally(() => {
					this.loading = false;
				});
		}
	}

	async onClickDownload(type: string) {
		this.downloading = true;
		try {
			let { data, headers } = await this.$http.get(this.$api3(`/survey-report${this.$toQueryString(this.formData)}&download`), {
				responseType: 'arraybuffer',
			});
			const blob = new Blob([data], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			});
			const link = document.createElement('a');
			link.href = URL.createObjectURL(blob);
			link.download = this.$getFileNameFromContentDisposition(headers);
			link.click();
		} catch (e) {
			this.$notify({
				title: 'Something wants wrong!',
				type: 'warning',
				message: 'Unable to download reports.',
			});
		} finally {
			this.downloading = false;
		}
	}

	@Watch('formData.range')
	onChangeRange(value: number) {
		this.queryBuilder.addListener('range', value);
	}

	@Watch('filters.user_ids')
	onChangeUsers(value: number) {
		this.queryBuilder.addListener('user_id', value);
	}

	@Watch('filters.for')
	onChangeFor(value: string) {
		this.queryBuilder.addListener('for', value);
	}

	@Watch('filters.badge_ids')
	onChangeBadges(value: number) {
		this.queryBuilder.addListener('badge_ids', value);
	}

	@Watch('filters.location_type_ids')
	onChangeLocationTypes(value: number) {
		this.queryBuilder.addListener('location_type_ids', value);
	}

	@Watch('filters.department_category_ids')
	onChangeDepartmentCategories(value: number) {
		this.queryBuilder.addListener('department_category_ids', value);
	}

	@Watch('filters.department_type_ids')
	onChangeDepartmentTypes(value: number) {
		this.queryBuilder.addListener('department_type_ids', value);
	}

	@Watch('filters.territory_ids')
	onChangeTerritories(value: number) {
		this.queryBuilder.addListener('territory_ids', value);
	}

	@Watch('filters.participant_code')
	onChangeParticipantCode(value: string) {
		this.queryBuilder.addListener('participant_code', value);
	}

	get permissionEnum() {
		return PermissionEnum;
	}
}
